import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateInput", "submitButton"]
  static values  = { 
    url: String,
    packageId: String,
    dronePointId: String 
  }

  connect() {
    document.getElementById("schedule-options")
            .addEventListener("turbo:frame-load", this.onFrameLoad.bind(this))

    if (this.dateInputTarget.value) {
      this.fetchOptions()
    }
  }

  fetchOptions() {
    const date = this.dateInputTarget.value
    if (!date) return

    const packageId = this.packageIdValue
    const dronePointId = this.dronePointIdValue

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("date", date)
    url.searchParams.set("package_id", packageId)
    url.searchParams.set("drone_point_id", dronePointId)

    const frame = document.getElementById("schedule-options")
    frame.setAttribute("src", url.toString())
  }

  onFrameLoad() {
    const hasSlots = document.querySelector(
      "input[name='booking[activities_attributes][0][activity_schedule_attributes][start_at]']"
    )
    hasSlots ? this.enableSubmit() : this.disableSubmit()
  }

  disableSubmit() {
    this.submitButtonTarget.disabled = true
  }

  enableSubmit() {
    this.submitButtonTarget.disabled = false
  }
}
